<template>
  <div>
    <v-row class="d-flex align-start">
      <v-col cols="12" sm="6" md="7" lg="7">
        <v-row class="d-flex justify-start align-center" no-gutters>
          <v-col cols="auto" class="mb-2 mb-sm-0">
            <v-card color="transparent" elevation="0" class="mr-4">
              <v-btn-toggle v-model="listView" tile color="deep-purple accent-3" group mandatory>
                <v-btn color="primary" value="list" icon>
                  <v-icon>mdi-view-list-outline</v-icon>
                </v-btn>
                <v-btn color="primary" value="grid" icon>
                  <v-icon>mdi-view-grid-outline</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-card>
          </v-col>
          <v-col cols="auto" class="mb-2 mb-sm-0">
            <v-card max-width="240" elevation="1" class="mr-4">
              <v-select max-width="300px" outlined dense :items="mediaSelectItems" hide-details color="primary" v-model="mediaFormat" :disabled="!!mediaSearch">
                <template v-slot:prepend-inner>
                  <v-icon size="17" color="grey darken-4" class="mt-1">mdi-file-search-outline</v-icon>
                </template>
              </v-select>
            </v-card>
          </v-col>
          <!-- <v-card max-width="180" elevation="1" class="mr-4">
          <v-select
            max-width="300px"
            outlined
            dense
            :items="dateSelectItems"
            hide-details
            color="primary"
            v-model="mediaTime"
          >
            <template v-slot:prepend-inner>
              <v-icon size="17" color="grey darken-4" class="mt-1">mdi-calendar-range</v-icon>
            </template>
          </v-select>
          </v-card>-->
          <v-col>
            <v-card v-if="!multipleSelect" elevation="0" color="transparent">
              <v-btn color="primary" text class="text-capitalize grey lighten-2" depressed :disabled="!mediaList.length" @click="multipleToggle">
                <v-icon left>mdi-checkbox-multiple-marked-outline</v-icon>
                {{ $t("PANEL.MEDIA.MEDIA_SUB_HEADER.MASS_SELECTING") }}
              </v-btn>
            </v-card>
            <v-card v-else elevation="0" color="transparent">
              <v-chip color="primary" label class="mr-3">
                {{
                  selectedFiles.length > 0
                    ? $t("PANEL.MEDIA.MEDIA_SUB_HEADER.SELECTED_FILE_COUNT", { COUNT: selectedFiles.length })
                    : $t("PANEL.MEDIA.MEDIA_SUB_HEADER.NOT_SELECT")
                }}
              </v-chip>
              <v-btn color="red" text class="text-capitalize grey lighten-2 mr-3" depressed @click="multipleToggle">
                <v-icon left>mdi-checkbox-multiple-marked-outline</v-icon>
                {{ $t("PANEL.MEDIA.MEDIA_SUB_HEADER.CANCEL") }}
              </v-btn>
              <v-btn
                color="red"
                class="text-capitalize"
                :class="selectedFiles.length == 0 ? 'grey lighten-2' : ''"
                :text="selectedFiles.length == 0"
                :dark="selectedFiles.length != 0"
                depressed
                :disabled="selectedFiles.length == 0"
                @click="removeFiles(selectedFiles.map(file => file.name))"
              >
                <v-icon left>mdi-trash-can-outline</v-icon>
                {{ $t("PANEL.MEDIA.MEDIA_SUB_HEADER.PERMANENTLY_DELETE") }}
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="d-flex align-center">
        <v-col cols="12" class="pa-0 pa-sm-2">
          <v-text-field
            solo
            dense
            hide-details
            :label="$t('PANEL.MEDIA.MEDIA_SUB_HEADER.SEARCH_LABEL')"
            prepend-inner-icon="mdi-magnify"
            clearable
            @keyup.enter="searchMedia"
            v-model="mediaSearch"
          ></v-text-field>
        </v-col>
      </v-col>
    </v-row>
    <div id="mediaListFiles">
      <v-container class="px-2">
        <div v-show="!noMediaItems" v-if="mediaList.length > 0">
          <v-row v-if="listView == 'grid'">
            <v-col
              cols="12"
              sm="4"
              md="3"
              lg="2"
              xl="2"
              :key="key"
              v-for="(file, key) in mediaList"
              @click="selectFile(file)"
              :class="{ 'wobble-hor-bottom': multipleSelect }"
            >
              <div class="media-item d-flex justify-center align-center rounded-lg overflow-hidden white elevation-2" v-ripple>
                <div class="media-item-context">
                  <file-thumbnailer :value="file" :viewport-height="thumbHeight()" padding="0 0 0 0" />
                </div>
                <div v-show="!isBaseImage(file.type)" class="media-item-text">{{ file.name }}</div>
                <span v-show="isSelected(file)" class="media-item-border">
                  <span class="media-item-border-icon">
                    <v-icon class="ml-3 mt-3" size="35" dark>mdi-check</v-icon>
                  </span>
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row v-else-if="listView == 'list'">
            <v-col cols="12" :key="key" v-for="(file, key) in mediaList" :class="{ 'wobble-hor-bottom': multipleSelect }">
              <v-container class="rounded-lg overflow-hidden white elevation-2">
                <v-row>
                  <v-col cols="12" md="3" class="py-0">
                    <div class="media-item-context">
                      <file-thumbnailer :value="file" viewport-height="160" padding="0 0 0 0" class="overflow-hidden rounded-lg" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="7">
                    <div class="mb-2">
                      <div>
                        <b>{{ $t("PANEL.MEDIA.LIST_VIEW.FILE_NAME") }}:</b>
                      </div>
                      <div class="grey--text text--darken-3">{{ file.name }}</div>
                    </div>
                    <div class="mb-2">
                      <div>
                        <b>{{ $t("PANEL.MEDIA.LIST_VIEW.SIZE") }}:</b>
                      </div>
                      <div>{{ file.size }}</div>
                    </div>
                    <div>
                      <v-btn small color="blue" dark @click="selectFile(file)">
                        <v-icon left>mdi-file-find</v-icon>
                        {{ $t("PANEL.MEDIA.LIST_VIEW.DETAILS") }}
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="12" md="2">
                    <div>
                      <b>{{ $t("PANEL.MEDIA.LIST_VIEW.UPLOADED_DATE") }}:</b>
                    </div>
                    <div class="d-flex align-center text-subtitle-2">
                      <v-icon size="18" class="mr-1">mdi-calendar-range</v-icon>
                      {{ fileDate(file.time) }}
                    </div>
                    <div class="d-flex align-center text-subtitle-2">
                      <v-icon size="18" class="mr-1">mdi-clock-outline</v-icon>
                      {{ fileTime(file.time) }}
                    </div>
                  </v-col>
                </v-row>
                <span v-show="isSelected(file)" class="media-item-border">
                  <span class="media-item-border-icon">
                    <v-icon class="ml-3 mt-3" size="35" dark>mdi-check</v-icon>
                  </span>
                </span>
              </v-container>
            </v-col>
          </v-row>
        </div>

        <div v-show="!noMediaItems" v-else>
          <v-row v-if="listView == 'grid'">
            <v-col cols="12" sm="4" md="3" lg="2" xl="3" :key="n" v-for="n in x">
              <v-skeleton-loader class="mx-auto" :height="thumbHeight()" type="card"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row v-else-if="listView == 'list'">
            <v-col cols="12" :key="n" v-for="n in x">
              <v-skeleton-loader class="mx-auto" height="160" type="card"></v-skeleton-loader>
            </v-col>
          </v-row>
        </div>

        <v-row v-if="mediaListPagination.loading">
          <v-col class="mx-auto mt-2" cols="12" lg="3">
            <div class="text-center">{{ $t("PANEL.MEDIA.LIST.LOADING_FILES") }}</div>
            <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
          </v-col>
        </v-row>

        <v-row v-if="noMediaItems">
          <v-col cols="12">
            <p class="text-h5 grey--text text-center mt-10">
              <b>{{ $t("PANEL.MEDIA.LIST.NO_MEDIA_CONTENT") }}</b>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <file-viewer v-model="fileInfoSelect" @deleted="removedFiles" @change="changedMediaListSingle" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FileThumbnailer from "./FileThumbnailer.vue";
import FileViewer from "./FileViewer.vue";
import MediaService from "@/services/MediaService";

export default {
  components: { FileThumbnailer, FileViewer },
  name: "MediaList",
  props: {
    update: {
      default: false,
      required: false
    }
  },
  data: () => ({
    listView: "grid",
    x: 12,
    listType: "list",
    mediaSelectItems: [],
    dateSelectItems: [],
    selectedFiles: [],
    multipleSelect: false,
    fileInfoSelect: {},
    mediaFormat: "",
    mediaTime: "",
    mediaSearch: "",
    noMediaItems: false,
    mediaListPagination: {
      start: 0,
      limit: 48,
      loading: false,
      mediaExist: true
    }
  }),
  computed: {
    ...mapState({
      mediaList: state => state.Media.MediaList.mediaList,
      acceptFilesList: state => state.Media.acceptFilesList,
      mediaListTypes: state => state.Media.mediaListTypes,
      mediaFormats: state => state.Media.mediaFormats
    }),
    ...mapGetters({
      isBaseImage: "Media/isBaseImage"
    })
  },
  methods: {
    thumbHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 250;
        case "sm":
          return 160;
        case "md":
          return 160;
        case "lg":
          return 160;
        case "xl":
          return 200;
      }
    },
    selectFile(file) {
      if (this.multipleSelect) {
        this.selectedFile(file);
      } else {
        this.selectedFileDialog(file);
      }
    },
    isSelected(file) {
      return this.selectedFiles.includes(file);
    },
    selectedFile(file) {
      let selectedFiles = this.selectedFiles;
      if (!selectedFiles.includes(file)) {
        selectedFiles.push(file);
      } else {
        selectedFiles.splice(selectedFiles.indexOf(file), 1);
      }
    },
    selectedFileDialog(file) {
      this.fileInfoSelect = file;
    },
    multipleToggle() {
      if (!this.multipleSelect) {
        this.multipleSelect = true;
      } else {
        this.multipleSelect = false;
        this.selectedFiles = [];
      }
    },
    mediaSelectsChanged() {
      const { mediaFormat, mediaTime } = this;
      Promise.resolve(this.resetMediaListLimit()).then(() => {
        this.$store
          .dispatch("Media/MediaList/getMediaList", {
            mediaFormat,
            mediaTime
          })
          .then(result => this.noItemsDetect(result.data));
      });
    },
    mediaListLimit() {
      if (this.mediaListPagination.mediaExist && !this.mediaListPagination.loading) {
        this.setMediaListLimit();
        const { mediaFormat, mediaTime } = this,
          { start, limit } = this.mediaListPagination;
        this.mediaListPagination.loading = true;
        this.$store
          .dispatch("Media/MediaList/getMediaListLimit", {
            mediaFormat,
            mediaTime,
            start,
            limit
          })
          .then(res => {
            if (res.data.length === 0) {
              this.mediaListPagination.mediaExist = false;
            }
            this.mediaListPagination.loading = false;
          });
      }
    },
    setMediaListLimit() {
      this.mediaListPagination.start += Number(this.mediaListPagination.limit);
      return this.mediaListPagination;
    },
    resetMediaListLimit() {
      this.mediaListPagination.start = 0;
      this.mediaListPagination.mediaExist = true;
      return this.mediaListPagination;
    },
    removeFiles(filesList) {
      MediaService.removeFiles(filesList).then(res => {
        if (res.status === 200) {
          this.removedFiles(filesList);
          this.multipleToggle();
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    removedFiles(fileNames) {
      fileNames = fileNames.constructor === Array ? fileNames : [fileNames];
      let mediaList = this.mediaList.filter(media => {
        return !fileNames.includes(media.name);
      });
      this.noItemsDetect(mediaList);
      this.$store.commit("Media/MediaList/setMediaList", mediaList);
    },
    searchMedia() {
      this.$store
        .dispatch("Media/MediaList/searchMedia", {
          search: this.mediaSearch
        })
        .then(result => this.noItemsDetect(result.data));
    },
    changedMediaListSingle(file) {
      return new Promise((resolve, reject) => {
        let search = file.name.replace(".", " ").split(" ")[0];
        MediaService.searchMedia({ search })
          .then(res => {
            let newFile = res.data[0];
            if (res.status === 200) {
              let mediaList = this.mediaList.filter(media => {
                return media.name !== newFile.name;
              });
              mediaList.unshift(newFile);
              this.$store.commit("Media/MediaList/setMediaList", mediaList);
            }
            resolve(res.data[0]);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    noItemsDetect(items) {
      this.noMediaItems = items.length === 0;
    },
    fileDate(date) {
      let newDate = date.split("-");
      return newDate[0];
    },
    fileTime(date) {
      let newTime = date.split("-");
      return newTime[1];
    }
  },
  created() {
    let self = this;

    /**
     * Medya listesi formatlarını getir
     */
    self.$store.dispatch("Media/getMediaFormats").then(() => {
      let formats = self.mediaFormats,
        formatItems = [];
      for (let format in formats) {
        formatItems.push({
          text: this.$t(`PANEL.MEDIA.MEDIA_TYPES.${formats[format].toUpperCase()}`),
          value: formats[format]
        });
      }
      this.mediaSelectItems = formatItems;
      this.mediaFormat = this.mediaSelectItems[0].value;
    });

    /**
     * Media tarih sorgusu için tarihleri ayarla
     */
    let selectDates;

    let treeMonths = new Date(Date.now());
    treeMonths.setMonth(treeMonths.getMonth() - 3);
    let sixMonths = new Date(Date.now());
    sixMonths.setMonth(sixMonths.getMonth() - 6);
    let oneYear = new Date(Date.now());
    oneYear.setMonth(oneYear.getMonth() - 12);

    selectDates = [
      {
        text: this.$t("PANEL.MEDIA.DATE_SELECTION.ALL_DATES"),
        value: ""
      },
      {
        text: this.$t("PANEL.MEDIA.DATE_SELECTION.THREE_MONTHS_AGO"),
        value: ["-4 month", "-3 month"]
      },
      {
        text: this.$t("PANEL.MEDIA.DATE_SELECTION.SIX_MONTHS_AGO"),
        value: ["-9 month", "-6 month"]
      },
      {
        text: this.$t("PANEL.MEDIA.DATE_SELECTION.LAST_YEAR"),
        value: [12, 12]
      }
    ];

    this.dateSelectItems = selectDates;
    this.mediaTime = selectDates[0].value;
  },
  mounted() {
    /**
     * Media List Offset Y
     */
    let mlContainer = document.getElementById("mediaListFiles"),
      html = document.querySelector("html");
    document.addEventListener("scroll", () => {
      if (this.mediaListPagination.limit >= this.mediaList) {
        let listArea = mlContainer.offsetTop + mlContainer.offsetHeight,
          actionArea = window.innerHeight + html.scrollTop - 55;
        if (actionArea > listArea) {
          this.mediaListLimit();
        }
      }
    });
  },
  watch: {
    mediaFormat: {
      handler(value) {
        if (value !== "undefined") {
          this.mediaSelectsChanged();
        }
      },
      immediate: true
    },
    mediaTime() {
      this.mediaSelectsChanged();
    },
    update() {
      this.mediaSelectsChanged();
    },
    mediaSearch() {
      this.mediaSearch = this.mediaSearch ?? "";

      if (!this.mediaSearch) {
        this.mediaSelectsChanged();
      } else {
        if (this.mediaFormat != this.mediaSelectItems[0].value) {
          this.mediaFormat = this.mediaSelectItems[0].value;
        }
      }
    }
  }
};
</script>

<style>
.media-item {
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: relative;
}

.media-item-context {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: absolute;
  width: 100%;
  font-size: 14px;
  padding: 0 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  text-overflow: clip ellipsis clip 0 3ch;
  direction: rtl;
  white-space: nowrap; */
}

.media-item-border {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.411);
  border-radius: 10px;
}

.media-item img {
  max-width: 100%;
}

.media-item-text {
  width: 100%;
  word-break: break-all;
  position: absolute;
  bottom: 0;
  padding: 0.5em;
  background: #ffffffa8;
  line-height: 1.5;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  text-overflow: clip ellipsis clip 0 3ch;
  direction: rtl;
  white-space: nowrap;
  -webkit-line-clamp: 3;
  text-align: center;
}

.wobble-hor-bottom {
  -webkit-animation: wobble-hor-bottom 0.65s both;
  animation: wobble-hor-bottom 0.65s both;
}

@-webkit-keyframes wobble-hor-bottom {
  0%,
  100% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: translateX(-30px) rotate(-6deg);
    transform: translateX(-30px) rotate(-6deg);
  }
  30% {
    -webkit-transform: translateX(15px) rotate(6deg);
    transform: translateX(15px) rotate(6deg);
  }
  45% {
    -webkit-transform: translateX(-15px) rotate(-3.6deg);
    transform: translateX(-15px) rotate(-3.6deg);
  }
  60% {
    -webkit-transform: translateX(9px) rotate(2.4deg);
    transform: translateX(9px) rotate(2.4deg);
  }
  75% {
    -webkit-transform: translateX(-6px) rotate(-1.2deg);
    transform: translateX(-6px) rotate(-1.2deg);
  }
}

@keyframes wobble-hor-bottom {
  0%,
  100% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: translateX(-30px) rotate(-6deg);
    transform: translateX(-30px) rotate(-6deg);
  }
  30% {
    -webkit-transform: translateX(15px) rotate(6deg);
    transform: translateX(15px) rotate(6deg);
  }
  45% {
    -webkit-transform: translateX(-15px) rotate(-3.6deg);
    transform: translateX(-15px) rotate(-3.6deg);
  }
  60% {
    -webkit-transform: translateX(9px) rotate(2.4deg);
    transform: translateX(9px) rotate(2.4deg);
  }
  75% {
    -webkit-transform: translateX(-6px) rotate(-1.2deg);
    transform: translateX(-6px) rotate(-1.2deg);
  }
}
</style>
